export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}role/role/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Role/index.js